export default __webpack_public_path__ + "static/media/promo_02.26434c33.jpg";